module.exports = __webpack_public_path__ + "img/20200610_160043.09fc1c85.jpg";